const SCPMainActivityXML =
    `<?xml version="1.0" encoding="utf-8"?>
<androidx.constraintlayout.widget.ConstraintLayout 
    xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:app="http://schemas.android.com/apk/res-auto"
    xmlns:tools="http://schemas.android.com/tools"
    android:layout_width="match_parent"
    android:layout_height="match_parent"
    tools:context=".MainActivity">

    <com.google.android.material.textfield.TextInputLayout
        android:id="@+id/textField"
        style="@style/Widget.MaterialComponents.TextInputLayout.OutlinedBox"
        android:layout_width="match_parent"
        android:layout_height="wrap_content"
        android:layout_marginStart="8dp"
        android:layout_marginEnd="8dp"
        android:hint="enter the text"
        app:layout_constraintBottom_toBottomOf="parent"
        app:layout_constraintEnd_toEndOf="parent"
        app:layout_constraintStart_toStartOf="parent"
        app:layout_constraintTop_toTopOf="parent"
        app:layout_constraintVertical_bias="0.40">

        <com.google.android.material.textfield.TextInputEditText
            android:id="@+id/edFileName"
            android:layout_width="match_parent"
            android:layout_height="wrap_content"
            android:inputType="textUri"
            tools:ignore="TextContrastCheck" />

    </com.google.android.material.textfield.TextInputLayout>

    <LinearLayout
        android:layout_width="match_parent"
        android:layout_height="wrap_content"
        android:orientation="horizontal"
        app:layout_constraintEnd_toEndOf="parent"
        app:layout_constraintStart_toStartOf="parent"
        app:layout_constraintTop_toBottomOf="@+id/textField">

        <Button
            android:id="@+id/shareDataBtn"
            style="?android:attr/buttonBarStyle"
            android:layout_width="match_parent"
            android:layout_height="match_parent"
            android:layout_margin="8dp"
            android:layout_weight="1"
            android:text="share" />

        <Button
            android:id="@+id/copyDataBtn"
            style="?android:attr/buttonBarStyle"
            android:layout_width="match_parent"
            android:layout_height="match_parent"
            android:layout_margin="8dp"
            android:layout_weight="1"
            android:text="copy" />

        <Button
            android:id="@+id/pasteDataBtn"
            style="?android:attr/buttonBarStyle"
            android:layout_width="match_parent"
            android:layout_height="match_parent"
            android:layout_margin="8dp"
            android:layout_weight="1"
            android:text="paste" />

    </LinearLayout>
</androidx.constraintlayout.widget.ConstraintLayout>`

const SCPMainActivityKT =
    `package com.example


import android.content.ClipData
import android.content.ClipboardManager
import android.content.Context
import android.content.Intent
import android.os.Bundle
import android.widget.Button
import android.widget.EditText
import android.widget.Toast
import androidx.appcompat.app.AppCompatActivity


class MainActivity : AppCompatActivity() {
    private lateinit var edFileName: EditText
    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)
        edFileName = findViewById(R.id.edFileName)

        // todo: share text
        findViewById<Button>(R.id.shareDataBtn).setOnClickListener {
            if (edFileName.text.isNotEmpty()) {
                shareText(this, edFileName.text.toString())
            } else {
                edFileName.error = "Required for share and copy"
            }
        }
        // todo: share text

        // todo: copy text
        findViewById<Button>(R.id.copyDataBtn).setOnClickListener {
            if (edFileName.text.isNotEmpty()) {
                copyToClipBoard(
                    this,
                    edFileName.text.toString()
                )
                Toast.makeText(this, "copied", Toast.LENGTH_LONG).show()
            } else {
                edFileName.error = "Required for share and copy"
            }
        }
        // todo: copy text

        // todo: paste text
        findViewById<Button>(R.id.pasteDataBtn).setOnClickListener {
            edFileName.setText(pasteFromClipBoard(this))
            Toast.makeText(this, "Pasted", Toast.LENGTH_LONG).show()
        }
        // todo: paste text

    }

    private fun copyToClipBoard(context: Context, text: String) {
        val clipboard = context.getSystemService(CLIPBOARD_SERVICE) as ClipboardManager
        val clip = ClipData.newPlainText("Copied Text", text)
        clipboard.setPrimaryClip(clip)
    }

    private fun shareText(context: Context, text: String) {
        val intent = Intent(Intent.ACTION_SEND)
        intent.type = "text/plain"
        intent.putExtra(Intent.EXTRA_TEXT, text)
        context.startActivity(Intent.createChooser(intent, "Share"))
    }

    private fun pasteFromClipBoard(context: Context): String {
        val clipboard = context.getSystemService(CLIPBOARD_SERVICE) as ClipboardManager
        return clipboard.primaryClip!!.getItemAt(0).text.toString()
    }
}`

module.exports = { SCPMainActivityXML: SCPMainActivityXML, SCPMainActivityKT: SCPMainActivityKT };
